import axios from 'axios';

const base = 'analitica-user';

function getAnaliticaIndividual(data) {
    return axios.post(`${base}/individual`, data);
}

function getUsuariosLista() {
    return axios.get(`${base}/usuarios`);
}

function getAnaliticaGeneral(data) {
    return axios.post(`${base}/general`, data);
}

const AnaliticaUserService = {
    getAnaliticaIndividual,
    getUsuariosLista,
    getAnaliticaGeneral,
};

export default AnaliticaUserService;
